export default __webpack_public_path__ + "static/media/controle-portao-eletronico.f4d9cc84.png";